import { MainContentWrapper, TableWrapper } from "../../../components/common/Common.styles";
import { Box } from "@mui/material";
import { ServerSidePagination } from "../../../components/common/table/ServerSidePagination";
import { GroupItem } from "../../../types/groupItem";
import { PaginatedData } from "../../../hooks/PaginationHooks";
import { useEffect } from "react";
import { fetchActionModules } from "../../../store/thunk/actionsModulesThunk";
import { useAppDispatch } from "../../../hooks/StoreHooks";
import EmployeesTableHeader from "./EmployeesTableHeader";
import EmployeesRow from "./EmployeesTableRow";
import { EmployeeUserType } from "../../../types/employeeType";

interface EmployeesTableProps {
  data: PaginatedData<EmployeeUserType>,
  groupList: GroupItem[];
}

function EmployeesTable(props: EmployeesTableProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchActionModules());
  }, [dispatch]);

  return (
    <MainContentWrapper>
      <TableWrapper
        columnsTemplate="1.25fr 1.25fr 1.17fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1.5fr 1fr"
        minWidth="1400px"
      >
        <EmployeesTableHeader paginatedData={props.data} />

        <Box sx={{ display: "contents" }}>
          {props.data.items.map((item) => (<EmployeesRow
            key={item.id}
            userData={item}
            groupList={props.groupList}
          />))}
        </Box>
      </TableWrapper>

      <ServerSidePagination paginatedData={props.data} />
    </MainContentWrapper>
  );
}

export default EmployeesTable;
